import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { StripeService } from 'src/app/services/stripe.service';

@Component({
	selector: 'app-welcome-purchase-configure',
	templateUrl: './purchase-configure.component.html',
	styleUrls: ['./purchase-configure.component.css']
})
export class WelcomePurchaseConfigureComponent implements OnInit {
	@ViewChild('inputClientId') inputClientId: ElementRef;
	@ViewChild('inputOauthSecret') inputOauthSecret: ElementRef;
	@ViewChild('inputApiKey') inputApiKey: ElementRef;
	@ViewChild('inputEmail') inputEmail: ElementRef;
	@ViewChild('selectUsersType') selectUsersType: ElementRef;

	loadingInit = true;
	loadingDownload;
	loadingPay;
	loadingContinue;

	form: UntypedFormGroup;

	expandInvoiceDetails = false;

	clientIdValid = false;
	oauthSecretValid = false;
	apiKeyValid = false;
	emailValid = false;

	errorEmailAddress = false;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		public contextService: ContextService,
		private dropboxService: DropboxService,
		private stripeService: StripeService,
		private router: Router
	) { }

	/** INIT FUNCTIONS */

	ngOnInit() {
		this.retrieveSubscriptions();
	}

	retrieveSubscriptions() {
		this.stripeService.getCurrentStripeSubscription(this.contextService.stripeCustomerId)
			.subscribe((subscription) => {
				console.log(subscription);
				this.formatSubscriptionDates(subscription);
			});
	}

	formatSubscriptionDates(subscription) {
		// invoiceExpirationDate
		let d = new Date(0);
		let utc = subscription.invoiceExpirationDate;
		d.setUTCSeconds(utc);
		subscription.invoiceExpirationDate = d;

		// subscriptionStartDate
		let d2 = new Date(0);
		let utc2 = subscription.subscriptionStartDate;
		d2.setUTCSeconds(utc2);
		subscription.subscriptionStartDate = d2;

		// subscriptionStartDate
		let d3 = new Date(0);
		let utc3 = subscription.subscriptionEndDate;
		d3.setUTCSeconds(utc3);
		subscription.subscriptionEndDate = d3;

		this.contextService.subscription = subscription;

		this.initForm();

		this.loadingInit = false;
	}

	/** FORM FUNCTIONS */

	initForm() {
		if (this.contextService.subscription.subscriptionType == 'shared') {
			this.form = this.fb.group({
				usersType: new UntypedFormControl('OAUTH', [Validators.required]),
				email: new UntypedFormControl('', [Validators.required, Validators.email]),
				clientId: new UntypedFormControl('', []),
				oauthSecret: new UntypedFormControl('', []),
				apiKey: new UntypedFormControl('', []),
			});
		} else {
			this.form = this.fb.group({
				usersType: new UntypedFormControl('OAUTH', [Validators.required]),
				email: new UntypedFormControl('', []),
				clientId: new UntypedFormControl('', [Validators.required]),
				oauthSecret: new UntypedFormControl('', [Validators.required]),
				apiKey: new UntypedFormControl('', [Validators.required]),
			});
		}
	}

	doClientIdValidation(e: any) {
		if (e.target.value) {
			this.clientIdValid = true;
		} else {
			this.clientIdValid = false;
		}
	}

	doOauthSecretValidation(e: any) {
		if (e.target.value) {
			this.oauthSecretValid = true;
		} else {
			this.oauthSecretValid = false;
		}
	}

	doApiKeyValidation(e: any) {
		if (e.target.value) {
			this.apiKeyValid = true;
		} else {
			this.apiKeyValid = false;
		}
	}

	doEmailValidation(e: any) {
		let emailValue = '';
		if (e.target?.value) {
			emailValue = e.target.value;
		} else {
			emailValue = e;
		}
		const regexPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (regexPattern.test(emailValue)) {
			this.emailValid = true;
		} else {
			this.emailValid = false;
		}
	}

	/** BUTTON ACTIONS */

	selectDownloadInvoice(subscriptionId) {
		this.loadingDownload = true;
		this.stripeService.getStripeInvoiceDownloadLink(this.contextService.stripeCustomerId, subscriptionId)
			.subscribe((result) => {
				window.open(result.paymentUrl, '_blank');
				this.loadingDownload = false;
			});
	}

	selectPayInvoice(subscriptionId) {
		this.loadingPay = true;
		this.stripeService.getStripeInvoiceDownloadLink(this.contextService.stripeCustomerId, subscriptionId)
			.subscribe((result) => {
				window.open(result.invoiceUrl, '_blank');
				this.loadingPay = false;
			});
	}

	selectContinue() {
		this.loadingContinue = true;
		if (this.contextService.subscription.subscriptionType == 'connector') {
			this.signupExistingAccount();
		} else {
			this.signupNewAccount();
		}
	}

	signupExistingAccount() {
		let clientDetailProcore;

		clientDetailProcore = {
			'clientId': this.contextService.clientDetailProcore.clientId,
			'companyId': this.contextService.procoreContextObject.context.company_id,
			'dropboxSignAPIKey': this.inputApiKey.nativeElement.value,
			'dropboxSignClientId': this.inputClientId.nativeElement.value,
			'dropboxSignOAUTHClientSecret': this.inputOauthSecret.nativeElement.value,
			'dropboxSignAccountType': this.selectUsersType.nativeElement.value,
			'subscriptionType': this.contextService.subscription.subscriptionType
		};

		this.clientService.updateClientDetailProcore(clientDetailProcore, false)
			.subscribe((clientDetailProcore) => {
				this.router.navigate(['/welcome/authenticate'], { queryParams: { accountType: this.contextService.subscription.subscriptionType, } });
			});
	}

	signupNewAccount() {
		this.dropboxService.assignUserToSharedTeam(this.inputEmail.nativeElement.value, this.contextService.procoreContextObject.context.company_id, this.selectUsersType.nativeElement.value, false)
			.subscribe((response) => {
				console.log(response);
				if (response == true) {
					// The user was invited to the team
					this.router.navigate(['/welcome/authenticate'], { queryParams: { accountType: this.contextService.subscription.subscriptionType, } });
				} else {
					// The user wasn't invited to the team
					this.errorEmailAddress = true;
					this.loadingContinue = false;
				}
			});
	}

}